import type {TipsCardSize} from '@/types/content';
import {TIPS_CARD_SIZES} from '@/types/content';

type TipsCardConfig = {size: TipsCardSize; borderless: boolean};

const TIPS_CARD_TYPE_CONFIG: Record<string, TipsCardConfig> = {
    BIG: {size: TIPS_CARD_SIZES.BIG, borderless: false},
    BIG_BORDERLESS: {size: TIPS_CARD_SIZES.BIG, borderless: true},
    SMALL: {size: TIPS_CARD_SIZES.SMALL, borderless: false},
    SMALL_BORDERLESS: {size: TIPS_CARD_SIZES.SMALL, borderless: true},
};

export const getTipsCardConfig = (type?: string | null) => {
    if (type && type in TIPS_CARD_TYPE_CONFIG) {
        return TIPS_CARD_TYPE_CONFIG[type];
    }

    return TIPS_CARD_TYPE_CONFIG.SMALL;
};
